<template>
    <field-wrapper
        id="customerDeliveryName"
        :label-text="texts.label"
        :error-text="errorMessage"
        :show-error="Boolean(errorMessage)"
    >
        <input-text
            id="customerDeliveryName_input"
            v-model="value"
            type="text"
            autocomplete="name"
            aria-describedby="customerDeliveryName_error"
            :aria-invalid="errorMessage ? 'true' : 'false'"
        />
    </field-wrapper>
</template>

<script>
import FieldWrapper from "@/components/elements/FieldWrapper";
import InputText from "@/components/inputs/InputText";

import { mapGetters, mapMutations } from "vuex";

export default {
    components: {
        FieldWrapper,
        InputText
    },
    props: {
        validate: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        texts() {
            return this.$t("field_customer_delivery_name");
        },
        value: {
            get() {
                return this.name || "";
            },
            set(deliveryName) {
                this.updateCustomer({ deliveryName });
            }
        },
        errorMessage() {
            if (this.validate && this.error)
                return this.$t(
                    `field_customer_delivery_name.${this.error}`,
                    1,
                    {
                        invalidChars: this.invalidChars.join("")
                    }
                );
            return null;
        },
        ...mapGetters({
            name: "customer/getDeliveryName",
            invalidChars: "customer/getDeliveryNameInvalidChars",
            error: "customer/getDeliveryNameError"
        })
    },
    methods: {
        ...mapMutations({
            updateCustomer: "customer/updateCustomer"
        })
    }
};
</script>
